import {$get, $post} from '../http';
import {baseUrl} from "@/request/global";

var api = baseUrl
//获取分类列表
export const getCategoryList = (params) => {
    return $get(api+'/idsp-pc/center-purchase/getCategoryList',params)
}
//获取行业列表
export const getIndustryList = (params) => {
    return $get(api+'/idsp-pc/center-purchase/getIndustryList',params)
}
//分页列表集采
export const centerpurchasepage = (params) => {
    return $get(api+'/idsp-pc/center-purchase/page',params)
}
//需求详情
export const centerpurchasedetail = (params) => {
    return $get(api+'/idsp-pc/center-purchase/detail',params)
}
//报名信息详情
export const centerpurchasejoindetail = (params) => {
    return $get(api+'/idsp-pc/center-purchase/join/detail',params)
}
//详情里的报名列表
export const centerpurchasejoinpage = (params) => {
    return $get(api+'/idsp-pc/center-purchase/join/page',params)
}
//根据需求查产品列表
export const centerpurchaseproductlist = (params) => {
    return $get(api+'/idsp-pc/center-purchase/product/list',params)
}

//报名
export const centerpurchaseenroll= (params) => {
    return $post(api+'/idsp-pc/center-purchase/enroll',params)
}
//获取报名产品分页数据
export const centerpurchasejoinproductlist = (params) => {
    return $get(api+'/idsp-pc/center-purchase/join/product/list',params)
}

//发布
export const centerpurchasesubmit= (params) => {
    return $post(api+'/idsp-pc/center-purchase/submit',params)
}


//报名企业列表含产品
export const centerpurchasejoindetaillist = (params) => {
    return $get(api+'/idsp-pc/center-purchase/join/detail/list',params)
}

//下载
export const centerpurchaseenrolllistdownload = (params) => {
return $get(api+'/idsp-pc/center-purchase/enroll/list/download',params,{type:3})
}


//查询用户手机号名称
export const getUserNamePhone = (params) => {
    return $get(api+'/idsp-pc/center-purchase/join/detail/nomask',params)
}


//查询用户手机号名称
export const getUserNamePhoneTwo = (params) => {
    return $get(api+'/idsp-pc/center-purchase/detail/nomask',params)
}



